import { default as _91_46_46_46slug_93WSi9hC2fgDMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/[...slug].vue?macro=true";
import { default as indexOdKgeWWOksMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/auth/index.vue?macro=true";
import { default as indexKGx8dncLeNMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93AWyM4ZiG41Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93P0ik9WWrkOMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93FlhaH8vtXSMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93KRbF2G1sbeMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/news/[slug].vue?macro=true";
import { default as organisationsKklviFfHgIMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventshwNLlKzZrpMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programs4Ndgc8dkZVMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexqYze5WshnSMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/processes/index.vue?macro=true";
import { default as dungeonB78Q0VpGtIMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsTIyxGEJ81eMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/secret/index/inputs.vue?macro=true";
import { default as index136AHy9eHVMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/secret/index.vue?macro=true";
import { default as indexYIJ1l8r0IfMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseData8hfFgPD3pPMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassWLHuwqbqUiMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93UOpFvknnAuMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexYrPNGORxtTMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataAmyqB0jZhaMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFields22aoK5b02jMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReports5G90LuHGYGMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsGkcS7P3BUnMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_9362gpaA6ZnUMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexWKDhJxBko2Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesnIUCFBQQ4aMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatapTaap0ZxE6Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93nTiQ6GRn26Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indextPH7O4EFidMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesWps9aRIxQsMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatavmdfrfFzuHMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93oceLnInePgMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as index95JeKNiwFRMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataojemNSE1OtMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93TdzMJ740MvMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexe03MpRgboAMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataPlzknGc5dBMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassf23i4cSGdYMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsQs8CAt6UcqMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_939EytatrXaNMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as index4dAEJ5vkk9Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesvbW3i6uY8JMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataPcDjjv4b1eMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsWvFJNeiSW5Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93fQ3BC6dfd3Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexx1WwhN0fSQMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesHRWpjhugTwMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataNuGZSr9MqHMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsqtQr4mF7yZMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93txAa4wff3NMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexOKup8CBXHwMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataITSMYe5B3pMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataeYziqfSVt6Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93hfMn8mPVcsMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index0tTa4LI3BkMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatagGOlvwhms0Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93xaAanfLWw3Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexwAkm18X4LYMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsI6pACAbsiXMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataxe0WcoOQExMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_935Y097OqhZIMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as index36SlsNSFFJMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesT8rXIRLS12Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivities9tvkORAQk7Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsgHJhX45mUyMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDatamPIqsoapElMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiaszExUdzTNrdMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesh3klzT1NsnMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93T5Gukm73XBMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexn7JpKLHhVtMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionshmaeKnwyexMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehlttHvd7Q3FX5Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataqJUlIu3yKqMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsf48ShWwzECMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_932LLeUUU1BiMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexitM6wBYV1MMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsp39A4TZZqJMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesk1wHBHW3ZHMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataDjvwABlEqBMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_931KZC2Sf1pRMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/[id].vue?macro=true";
import { default as indexnHOK21X6b4Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_93hNwIvAFSheMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexyPCLzcebu2Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersdvPCJdvVwcMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesPvwumaODZeMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsliYHVKaXe9Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataCsJ8qLfDWsMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesMU9qxCg6XkMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcepttCLPAxRqg8Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementTk0KCQ5jJrMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersmFPpGVH9VPMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93pOEXCkcqIGMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexvk6FnPxtsdMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsgqGQashQtDMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesvXf6LKHdxFMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataRUVPDU0pTEMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureiX5ZFyBU3lMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93p9ElneoYxlMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexeyQMHnDO0eMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/index.vue?macro=true";
import { default as userssd8a7PWt9xMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users.vue?macro=true";
import { default as settingscqtJJckX9YMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesNqmNWWCtYMMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataDannb3O4ztMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93YfE4Vmy62jMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexQBLVkMt68JMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as service686mnhkUPiMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service.vue?macro=true";
import { default as languageMNBfE00qNNMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseData93VF1LRaN4Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesET6NhnQEDeMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementbXMoF2HhNPMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers9V0jOWC7nQMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93UC6T6UEIsCMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataoMDuDwwns3Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureJgCjBTWT8CMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93r5PPyK02u5Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/[id].vue?macro=true";
import { default as indexEsnaO6wYRGMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/index.vue?macro=true";
import { default as settingsWjHajFl1eZMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings.vue?macro=true";
import { default as signaturenC3cgfyykiMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/signature.vue?macro=true";
import { default as sportbizz3WGJFY4VfSMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93l6cBuk4ZhLMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93EUd923nyN9Meta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexZV239AEGBaMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93iayGWhLqJCMeta } from "/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93WSi9hC2fgDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexOdKgeWWOksMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexKGx8dncLeNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93AWyM4ZiG41Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93P0ik9WWrkOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93FlhaH8vtXSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsKklviFfHgIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexqYze5WshnSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: service686mnhkUPiMeta?.name,
    path: "/service",
    meta: service686mnhkUPiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatagGOlvwhms0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexYIJ1l8r0IfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93UOpFvknnAuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexYrPNGORxtTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_9362gpaA6ZnUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexWKDhJxBko2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93nTiQ6GRn26Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indextPH7O4EFidMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93oceLnInePgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: index95JeKNiwFRMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93TdzMJ740MvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexe03MpRgboAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_939EytatrXaNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: index4dAEJ5vkk9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93fQ3BC6dfd3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexx1WwhN0fSQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93txAa4wff3NMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsqtQr4mF7yZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexOKup8CBXHwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93hfMn8mPVcsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index0tTa4LI3BkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93xaAanfLWw3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesT8rXIRLS12Meta?.name,
    path: "parishes",
    meta: parishesT8rXIRLS12Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_935Y097OqhZIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionshmaeKnwyexMeta?.name,
    path: "regions",
    meta: regionshmaeKnwyexMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93T5Gukm73XBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsp39A4TZZqJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_932LLeUUU1BiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexitM6wBYV1MMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_931KZC2Sf1pRMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexnHOK21X6b4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingscqtJJckX9YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersdvPCJdvVwcMeta?.name,
    path: "loginProviders",
    meta: loginProvidersdvPCJdvVwcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93hNwIvAFSheMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexyPCLzcebu2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsgqGQashQtDMeta?.name,
    path: "organisations",
    meta: organisationsgqGQashQtDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93pOEXCkcqIGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexvk6FnPxtsdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: userssd8a7PWt9xMeta?.name,
    path: "users",
    meta: userssd8a7PWt9xMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93p9ElneoYxlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexeyQMHnDO0eMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93YfE4Vmy62jMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexQBLVkMt68JMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsWjHajFl1eZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93UC6T6UEIsCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93r5PPyK02u5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexEsnaO6wYRGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturenC3cgfyykiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizz3WGJFY4VfSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93l6cBuk4ZhLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93EUd923nyN9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexZV239AEGBaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93iayGWhLqJCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250522142355/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]